export enum PosSystems {
  Clover = 1,
  Cova = 2,
  Surge = 3,
  Pax = 4
}
